<div class="slider-aeioros-app" *ngIf="imageObject">
    <!--
      <ng-image-slider
        #nav
        [images]="imageObject"
        [infinite]="false"
        [autoSlide]="1"
        [imageSize]="{width: '100%', height: 600}"
        slideImage="1"></ng-image-slider>-->
  
    <!--<<ul>
          <li *ngFor="let img of imageObject">
              <div class="home-slider">
                  <h2 class="shadowtext">{{ img.title }}</h2>
                  <h6 class="shadowtext">{{ img.description }}</h6>
              </div>
              
              <div class="home-slider"><img class="imagen" src="{{ img.image }}" alt="{{ img.title }}" /></div>
              </div>
  
          </li>
      </ul>-->
  
    <div id="myCarousel" class="carousel slide" data-ride="carousel" >
      <div class="carousel-inner">
        <div *ngFor="let img of imageObject" class="carousel-item {{ img.status }}">
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6 home-slider">
              <img class="imagen" src="{{ img.image }}" alt="{{ img.title }}" />
            </div>
          </div>
          <div class="carousel-caption">
            <div class="content-text">
              <div class="col col-md-6">
                <h1 class="shadowtext">{{ img.titleKey ? (img.titleKey | translate) : img.title }}</h1>
                <p class="shadowtext">{{ img.descriptionKey ? (img.descriptionKey | translate) : img.description }}</p>
              </div>
            </div>
          </div>
        </div>
  
        <button class="carousel-control-prev" type="button" data-target="#myCarousel" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">{{ 'COMMON.CAROUSEL.PREV' | translate }}</span>
        </button>
        <button class="carousel-control-next" type="button" data-target="#myCarousel" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">{{ 'COMMON.CAROUSEL.NEXT' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
  